define([
    'underscore',
    //'./config/RouteConfig',
    'edge/quoteandbind/common/config/RouteConfig',
    'edge/platform/featuredetection/ApplicationFeatures',

    'text!./config/metadata/QuestionSets.json',

    './services/EmailService',
    './services/LoadSaveService',
    './services/ErrorHandlingService',
    './services/CustomQuoteService',
    './services/PolicyService',
    './services/UserAccountService',
    './services/InputValidationService',

    './directives/WizardSidebarAdditional',
    './directives/EditableCoverages',
    './directives/ReadonlyCoverages',
    './directives/CoveragePremiums',
    './directives/QuotePolicyBox',
    './directives/QuoteDetailsBox',
    './directives/QuoteComparisonPanel',
    './directives/Money',
    'integration/quoteandbind/directives/QnbInfoBar',
    'integration/quoteandbind/directives/Confirmation',
    'integration/quoteandbind/directives/QuoteOffering',
    'integration/quoteandbind/directives/CustomQuote',
    'integration/quoteandbind/directives/LobSelection',
    'integration/quoteandbind/config/CompositeFlowConfig',
    'integration/quoteandbind/config/DefaultProductProvider',

    'edge/policyjob/app',
    'edge/platform/base/module',
    'edge/platform/questionsets/module',
    'edge/platform/widgets/modal/module',
    'edge/platform/widgets/inputs/module',
    'edge/platform/widgets/list/module',
    'edge/platform/widgets/loading/module',
    'edge/platform/paymentdetails/module',
    'edge/platform/widgets/datetimepicker/module',
    'edge/platform/widgets/accordion/module',
    'edge/platform/widgets/basicinputs/module',
    'edge/platform/viewmodel/aspects/module',
    'edge/platform/flow/module',
    'edge/platform/widgets/wizard/module',

    'portalConfig',
    'angularRouter'
], (_, RouteConfig, ApplicationFeatures, QuestionSets,
    EmailService, LoadSaveService, ErrorHandlingService, CustomQuoteService, PolicyService, UserAccountService, InputValidationService,
    WizardSidebarAdditional, EditableCoverages, ReadonlyCoverages, CoveragePremiums, QuotePolicyBox, QuoteDetailsBox, QuoteComparisonPanel, Money, InfoBar,
    Confirmation, QuoteOffering, CustomQuote, LobSelection, CompositeFlowConfig, DefaultProductProvider)=> {
    const questionSets = JSON.parse(QuestionSets);

    return angular.module('edge.quoteandbind.common.app', [
            'edge.policyjob.app',
            'portal.config',
            'edge.platform.base',
            'edge.platform.questionsets',
            'ui.router',
            'edge.platform.widgets.loadingMsg',
            'edge.platform.widgets.modal',
            'edge.platform.widgets.inputs',
            'edge.platform.widgets.table',
            'edge.platform.paymentdetails',
            'edge.platform.widgets.ui.bootstrap.datetimepicker',
            'edge.platform.widgets.ui.bootstrap.accordion',
            'edge.platform.widgets.basicinputs',
            'edge.platform.viewmodel.aspects',
            'edge.platform.flow',
            'edge.platform.widgets.wizard'
        ])

        .constant('lobConfig', {
            lobs: ApplicationFeatures.getAllFeatures().quoteandbind_lob
        })

        .config(['$stateProvider', 'state_plugin_config', ($stateProvider, RootStateConfig)=> {
            const states = new RouteConfig(RootStateConfig);
            for (const stateName in states) {
                if (states.hasOwnProperty(stateName)) {
                    $stateProvider.state(stateName, states[stateName]);
                }
            }
        }])

        .config(['QuestionSetServiceProvider', (QuestionSetServiceProvider)=> {
            QuestionSetServiceProvider.addQuestionSets(questionSets);
        }])

        .factory('qnb.ErrorHandlingService', ErrorHandlingService)
        .factory('qnb.EmailService', EmailService)
        .factory('qnb.LoadSaveService', LoadSaveService)
        .factory('qnb.CustomQuoteService', CustomQuoteService)
        .factory('qnb.PolicyService', PolicyService)
        .factory('qnb.UserAccountService', UserAccountService)
        .factory('qnb.InputValidationService', InputValidationService)

        .directive('gwQnbInfoBar', InfoBar)
        .directive('gwWizardSidebarAdditional', WizardSidebarAdditional)
        .directive('gwQnbEditableCoverages', EditableCoverages)
        .directive('gwQnbReadonlyCoverages', ReadonlyCoverages)
        .directive('gwQnbQuotePolicyBox', QuotePolicyBox)
        .directive('gwQnbQuoteOffering', QuoteOffering)
        .directive('gwQnbQuoteDetailsBox', QuoteDetailsBox)
        .directive('gwQnbCoveragePremiums', CoveragePremiums)
        .directive('gwQnbCustomQuote', CustomQuote)
        .directive('gwQnbConfirmation', Confirmation)
        .directive('gwQnbQuoteComparisonPanel', QuoteComparisonPanel)
        .directive('gwQnbMoney', Money)
        .directive('gwLobSelection', LobSelection)

        .factory('qnb.CompositeFlowDefn', CompositeFlowConfig)
        .factory('qnb.DefaultProductProvider', DefaultProductProvider)

        .value('qnb.ViewModelCtx', {
            'AccountEmailRequired': true,
            'DriverEmailRequired': true,
            'AccountDOBRequired': true
        })

        .value('qnb.endpointConfig', {
            'loadSaveEndpoint': 'quote',
            'emailEndpoint': 'quote'
        })

        .value('qnb.returnStateFn', () => ['zipCode']);
});



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/app.js
 **/